// @flow
import { connect } from "react-redux";

import { createSelector } from "reselect";
import memoize from "lodash/memoize";

import { getLocales, getLocale } from "../redux/selectors/i18n";

import type { ReduxState } from "../redux/types";
import type { ComponentType } from "react";

type StateProps = {
  +message: (
    id: string,
    defaultMessage: string,
    placeholders: { ... },
  ) => string,
};

type Props = {
  ...StateProps,
  ...
};

const getMessage = createSelector(
  [getLocales, getLocale],
  (locales, localeCode) =>
    memoize(
      (id: string, defaultMessage?: string, placeholders?: Object) =>
        locales
          .getLocale(localeCode)
          .getMessage(id, defaultMessage, placeholders),
      (...args) => JSON.stringify(args),
    ),
);

const mapStateToProps = (state: ReduxState): StateProps => ({
  message: getMessage(state),
});

/**
 */
const withMessage: ComponentType<any> = connect<Props, {}, StateProps, _, _, _>(
  mapStateToProps,
);

export default withMessage;
